import React from 'react';
import { Marker, Pane, Polyline, Popup } from 'react-leaflet';
import { getArrowIcon, getStatusMarkerIcon, routePriority } from '../OrdersMap';

interface OrdersRoutesLayerProps {
  orders: any[];
  orderStatuses: Record<string, { color: string }>;
  indexPriority: (idx: number) => number;
}

export const OrdersRoutesLayer = ({ orders, orderStatuses, indexPriority }: OrdersRoutesLayerProps) => {
  if (!orders?.length) { return null; }

  return (
    <>
      {orders
        ?.filter(order => ['RECEIVED_FROM_STORE', 'READY', 'DISPATCHED', 'DELIVERED']?.includes(order.status))
        .map((order, i) => {
          const statusIcon = getStatusMarkerIcon(order.status, false);
          const missionRoute = (order as any)?.geojsonLine?.features?.[0]?.geometry?.coordinates?.map(
            (point: number[]) => [point[1], point[0]]
          );

          return (
            <div key={`${order.id}-${i}-arrow-routes`}>
              {missionRoute?.length ? (
                <Pane
                  key={`${order.id}-route-routes`}
                  name={`${order.id}-route-routes`}
                  style={{ zIndex: routePriority(false, order?.status) }}
                >
                  <Polyline
                    weight={3}
                    positions={missionRoute as any}
                    color={orderStatuses[order.status].color}
                    interactive={false}
                  />

                  {/* Disable arrows on Espoo and Espoo Test Site */}
                  {![12, 13].includes(order.cellId) && missionRoute.map((point: any, index: number) => {
                    if (index === missionRoute.length - 1) return null;
                    const nextPoint = missionRoute[index + 1];
                    const dy = nextPoint[0] - point[0];
                    const dx = Math.cos(Math.PI / 180 * point[0]) * (nextPoint[1] - point[1]);
                    let ang = ((Math.atan2(dy, dx) / Math.PI) * 180 * -1);
                    ang = parseFloat(ang.toFixed(2));
                    const arrowColor = orderStatuses[order.status].color;
                    const arrowIcon = getArrowIcon(ang, arrowColor, false);
                    return (
                      <Marker
                        key={`${order.id}-${index}`}
                        position={point}
                        icon={arrowIcon}
                        // @ts-ignore
                        rotationAngle={ang}
                        interactive={false}
                      />
                    );
                  })}
                </Pane>
              ) : null}
              <Pane
                key={`${order.id}-marker-routes`}
                name={`${order.id}-marker-routes`}
                style={{ zIndex: indexPriority(4) }}
              >
                <Marker
                  // @ts-ignore
                  position={order.dropLatlng ? order.dropLatlng.split(',').map((coordinate: string) => coordinate.trim()) : [0, 0]}
                  icon={statusIcon}
                  // @ts-ignore
                  style={{ zIndex: indexPriority(4) }}
                >
                  <Popup>
                    <div key="ordermap">Order: #{order.id.slice(0, 8)}</div>
                    <div key="orderstatus">Status: {order.status}</div>
                    <div key="ordereircode">Eircode: {order.eircode}</div>
                  </Popup>
                </Marker>
              </Pane>
            </div>
          );
        })}
    </>
  );
};

export default OrdersRoutesLayer;


